import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { create } from 'store/modules/lead';
import { LeadForm } from 'components';

const propTypes = {
  facilityId: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func,
  isSubmitting: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  sourceName: PropTypes.string,
  submitText: PropTypes.string,
};

const defaultProps = {
  facilityId: undefined,
  onSubmitted: undefined,
  errorMessage: '',
  sourceName: undefined,
  submitText: undefined,
};

const LeadFormContainer = ({
  facilityId,
  onSubmit,
  onSubmitted,
  isSubmitting,
  errorMessage,
  sourceName,
  submitText,
}) => {
  const handleSubmit = ({ facilityId: submittedFacilityId, ...tenant }) => {
    if (tenant.phone) {
      tenant.phone = tenant.phone.replace(/\D/g, '');
    }

    // If the form does not pass a facility ID it's because one was already
    // present for the page so use that one instead.
    onSubmit(submittedFacilityId || facilityId, sourceName, tenant)
      .then(() => {
        if (isSubmitting || errorMessage) {
          return;
        }

        if (typeof onSubmitted === 'function') {
          onSubmitted();
        }
      });
  };

  return <LeadForm
    facilityId={facilityId}
    onSubmitted={onSubmitted}
    isSubmitting={isSubmitting}
    errorMessage={errorMessage}
    sourceName={sourceName}
    submitText={submitText}
    onSubmit={handleSubmit}
  />;
};

LeadFormContainer.propTypes = propTypes;
LeadFormContainer.defaultProps = defaultProps;

const mapStateToProps = state => ({
  facilityId: (state.page && state.page.facilityId) || (state.pageBuilder && state.pageBuilder.facilityId),
  isSubmitting: state.lead.creating,
  errorMessage: state.lead.errorMessage,
});

const mapDispatchToProps = {
  onSubmit: create,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeadFormContainer);
